import { FC } from 'react';
import { Card, Button } from 'react-daisyui';
import { useNavigate } from 'react-router-dom';
import Routes from '@/router/Routes';
import { useAuthContext } from '@/context/AuthContext';

const CompanyLoginPage: FC = () => {
  const navigate = useNavigate();
  const { loginQuery } = useAuthContext();

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const email = formData.get('email') as string;
    const password = formData.get('password') as string;

    try {
      await loginQuery.mutateAsync({ email, password });
      navigate(Routes.COMPANY__DASHBOARD);
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-base-200">
      <Card className="w-full max-w-md shadow-xl">
        <Card.Body>
          <h2 className="card-title text-2xl font-bold mb-4">Company Admin Login</h2>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="form-control">
              <label className="label">
                <span className="label-text">Email</span>
              </label>
              <input
                type="email"
                name="email"
                placeholder="admin@company.com"
                className="input input-bordered"
                required
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Password</span>
              </label>
              <input
                type="password"
                name="password"
                placeholder="••••••••"
                className="input input-bordered"
                required
              />
            </div>
            <div className="form-control mt-6">
              <Button type="submit" color="primary" fullWidth loading={loginQuery.isPending}>
                Login
              </Button>
            </div>
          </form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CompanyLoginPage;

